export default __webpack_public_path__ + "Last-icon.svg";